import { Component } from '@angular/core';
import { Footer } from '../../components/footer/footer';
import { OrganizerHeroSection } from '../../components/organier-components/organizer-hero-section/organizer-hero-section';
import { OrganizerFlowSection } from '../../components/organier-components/organizer-flow-section/organizer-flow-section';
import { OrganizerLine } from '../../components/organier-components/organizer-line/organizer-line';
import { OrganizerGrow } from '../../components/organier-components/organizer-grow/organizer-grow';
import { OrganizerClient } from '../../components/organier-components/organizer-client/organizer-client';
import { OrganizerHelp } from '../../components/organier-components/organizer-help/organizer-help';
import { OrganizerTestimonial } from '../../components/organier-components/organizer-testimonial/organizer-testimonial';
import { OrganizerInterest } from '../../components/organier-components/organizer-interest/organizer-interest';
@Component({
  selector: 'app-organizer',
  imports: [
    Footer,
    OrganizerHeroSection,
    OrganizerFlowSection,
    OrganizerLine,
    OrganizerGrow,
    OrganizerClient,
    OrganizerHelp,
    OrganizerTestimonial,
    OrganizerInterest,
  ],
  templateUrl: './organizer.html',
  styleUrl: './organizer.css',
})
export class Organizer {}
